import { render, staticRenderFns } from "./zhuantiZhuanlan.vue?vue&type=template&id=23f0136f&scoped=true&"
import script from "./zhuantiZhuanlan.vue?vue&type=script&lang=js&"
export * from "./zhuantiZhuanlan.vue?vue&type=script&lang=js&"
import style0 from "./zhuantiZhuanlan.vue?vue&type=style&index=0&id=23f0136f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0136f",
  null
  
)

export default component.exports